/* Lazy room videos — Polton All Stars.

   Her choice, 17 Sep 2026: keep the full-length clips but do not make every
   visitor download them up front. Our Rooms was heading for ~8MB with four
   rooms, which is a lot on mobile data for a page most parents skim.

   So each <video data-lazy-video> ships with preload="none" and its real URL
   parked in data-src. The file is only fetched once the video is close to the
   viewport, and playback pauses again when it scrolls well away, so a phone is
   not decoding four clips at once.

   The poster is the room photograph, so the slot never flashes empty.
   muted + playsinline stay on the element: without both, iOS refuses to play. */
(function () {
  var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-lazy-video]'));
  if (!vids.length) return;

  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused; poster stands in */ });
  }

  function load(v) {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    var src = v.querySelector('source[data-src]');
    if (!src || src.src) { play(v); return; }

    /* preload="none" means load() alone fetches almost nothing, and calling
       play() straight after load() races it and rejects with an AbortError —
       which is why an earlier version marked videos as loaded while never
       downloading them or starting. Flip preload, then wait for the element to
       say it has data before asking it to play. */
    v.preload = 'auto';
    src.src = src.getAttribute('data-src');
    v.addEventListener('loadeddata', function () { play(v); }, { once: true });
    v.load();
  }

  /* No IntersectionObserver: load everything and behave as before. */
  if (!('IntersectionObserver' in window)) {
    vids.forEach(function (v) { load(v); });
    return;
  }

  /* Fetch a little before it is reached, so it is ready by the time it is seen. */
  var loader = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      load(e.target);
      loader.unobserve(e.target);
    });
  }, { rootMargin: '100px 0px' });

  /* Stop decoding what nobody is looking at. */
  var player = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.target.dataset.loaded) return;
      if (e.isIntersecting) play(e.target);
      else e.target.pause();
    });
  }, { threshold: 0.1 });

  vids.forEach(function (v) { loader.observe(v); player.observe(v); });
})();

/* Room slideshows — The Garden. Cross-fades through its photographs.

   Only runs while the slideshow is on screen, so a phone is not repainting
   something nobody can see, and it stops entirely for anyone who has asked for
   reduced motion — for them the first photograph simply stands. */
(function () {
  var sets = Array.prototype.slice.call(document.querySelectorAll('[data-roomslides]'));
  if (!sets.length) return;

  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (still) return;

  sets.forEach(function (set) {
    var imgs = Array.prototype.slice.call(set.querySelectorAll('.n-roomslides__img'));
    if (imgs.length < 2) return;
    var i = 0, timer = null;

    function step() {
      imgs[i].classList.remove('is-on');
      i = (i + 1) % imgs.length;
      imgs[i].classList.add('is-on');
    }
    function start() { if (!timer) timer = setInterval(step, 4200); }
    function stop() { clearInterval(timer); timer = null; }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.15 }).observe(set);
    } else {
      start();
    }

    /* Hovering or touching holds it, so a parent can actually look at one. */
    set.addEventListener('mouseenter', stop);
    set.addEventListener('mouseleave', start);
    set.addEventListener('touchstart', stop, { passive: true });
  });
})();
